import './globals'; // Adjust if needed
import React, { Component } from "react";
import screenfull from "screenfull";
import "./App.css";




// Gradient sets
const gradientSets = [
  {
    id: "lemon_sun_aqua_gradient",
    gradient: "linear-gradient(90deg, rgba(131,255,128,1) 0%, rgba(233,255,89,1) 58%, rgba(69,252,212,1) 100%)"
  },
];

class App extends Component {
  constructor(props) {
    super(props);

    const selectedGradient =
      gradientSets[this.getRandomInt(0, gradientSets.length)];
    const numberOfDivs = this.getRandomInt(22, 22);
    console.log(
      "♻️ RECYCLED INTERNETS ♻️",
      numberOfDivs,
      "recycled images on",
      selectedGradient.id
    );
    // const numberOfImages = numberOfDivs * 1;
    const selectedImages =[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

    this.state = {
      divs: this.initializeDivs(numberOfDivs, selectedImages),
      selectedGradient,
      selectedImages,
    };

    this.updateIntervals = {};
    this.scaleIntervals = {}; // New intervals for scale updates
  }

  componentDidMount() {
   
    // Start the update timers:
    // – The image (and position) update is scheduled randomly.
    this.startUpdates();
    // – The scale update is now independent and runs every 300ms.
    this.startScaleUpdates();
  }

  componentWillUnmount() {
    Object.values(this.updateIntervals).forEach(clearTimeout);
    Object.values(this.scaleIntervals).forEach(clearTimeout);
  }

  getRandomInt(min, max) { 
      return Math.floor(Math.random() * (max - min) + min);
  }

  getRandomScale() {
      return Math.random() * (2 - 0.08) + 0.08;
  }

  initializeDivs(count, images) {
    return Array.from({ length: count }, () => ({
      currentImage: images[this.getRandomInt(0, images.length)],
      scale: this.getRandomScale(),
      position: this.getRandomPosition(),
    }));
  }

  getRandomPosition() {
    return {
      top: `${this.getRandomInt(-20, 120)}%`,
      left: `${this.getRandomInt(-20, 120)}%`,
    };
  }

  startUpdates() {
    // Update the image and position at random intervals.
    // The scale property is no longer updated here.
    this.state.divs.forEach((_, index) => {
      const updateDiv = () => {
        this.setState((prevState) => {
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            ...newDivs[index], // Preserve the current scale.
            currentImage:
              prevState.selectedImages[
                this.getRandomInt(0, prevState.selectedImages.length)
              ],
            position: this.getRandomPosition(),
          };
          return { divs: newDivs };
        });
        this.updateIntervals[index] = setTimeout(
          updateDiv,
          this.getRandomInt(200, 5000)
        );
      };
      this.updateIntervals[index] = setTimeout(
        updateDiv,
        this.getRandomInt(200, 5000)
      );
    });
  }

  startScaleUpdates() {
    // Independently update the scale at random intervals between 500ms and 2000ms.
    this.state.divs.forEach((_, index) => {
      const updateScale = () => {
        this.setState((prevState) => {
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            ...newDivs[index],
            scale: this.getRandomScale(),
          };
          return { divs: newDivs };
        });
        this.scaleIntervals[index] = setTimeout(updateScale, this.getRandomInt(500, 2000));
      };
      this.scaleIntervals[index] = setTimeout(updateScale, this.getRandomInt(500, 2000));
    });
  }
  


  goFullScreen = () => {
    const element = document.querySelector(".App");
    if (screenfull.isEnabled && element) {
      screenfull.request(element);
    }
  };

 

  render() {
    const { selectedGradient } = this.state;

    return (
      <div
        className="App"
        style={{
          background: selectedGradient.gradient,
          backgroundSize: "700% 700%",
          animation: "AnimationName 60s ease infinite",
        }}
      >
        {this.state.divs.map((div, index) => (
          <div
            className="theArt"
            key={index}
            onClick={() => this.goFullScreen()}
            style={{
              position: "absolute",
              top: div.position.top,
              left: div.position.left,
              transform: `translate(-50%, -50%) scale(${div.scale})`,
            }}
          >
            <img src={require(`./images/${div.currentImage}.gif`)} alt={`art${index + 1}`} />
          </div>
        ))}
        <canvas id="captureCanvas" style={{ display: "none" }}></canvas>


      
      </div>
    );
  }
}

export default App;